import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import StepContent from '@mui/material/StepContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { useFlow } from '../context/FlowContext';
import { useI18N } from '../context/I18NContext';
import { useSettings } from '../context/SettingsContext';
import useWidgetStore from '../store/useWidgetStore';
const VerticalNav = ({ children }) => {
    const { t } = useI18N();
    const [showSummary, setShowSummary] = useState(false);
    const { hasBooking } = useWidgetStore();
    const { hasAccounts } = useSettings();
    const { currentRoute } = useFlow();
    const [activeStep, setActiveStep] = useState(0);
    const [steps, setSteps] = useState([]);
    const [hasBack, setHasBack] = useState(true);
    const flow = useFlow();
    useEffect(() => {
        let _steps = [];
        flow.views.forEach((view) => {
            _steps.push(view.route);
        });
        setSteps(_steps);
        setActiveStep(flow.currentStep);
    }, [flow.currentView]);
    useEffect(() => {
        // if (flow) {
        //     flow?.checkFlow()
        // }
    }, []);
    useEffect(() => {
        var _a, _b, _c;
        if (flow === null || flow === void 0 ? void 0 : flow.insideFlow) {
            let view = flow.views[flow.currentStep];
            setHasBack(!(((_a = view === null || view === void 0 ? void 0 : view.config) === null || _a === void 0 ? void 0 : _a.hasPrevious) !== undefined && !((_b = view === null || view === void 0 ? void 0 : view.config) === null || _b === void 0 ? void 0 : _b.hasPrevious)));
        }
        setShowSummary(hasBooking === true && !['select', 'select1', 'select2', 'summary', 'thankYou'].includes((_c = currentRoute === null || currentRoute === void 0 ? void 0 : currentRoute.route) !== null && _c !== void 0 ? _c : ''));
    }, [flow === null || flow === void 0 ? void 0 : flow.currentRoute]);
    let bottom = 0;
    if (hasAccounts)
        bottom += 60;
    return (_jsx(Box, { sx: {
            flexGrow: 1,
            paddingTop: showSummary ? '60px' : 0
        }, children: _jsx(Box, { sx: { padding: 1, minHeight: '100vh', maxWidth: 'calc(100vw - 16px)' }, children: _jsx(Stepper, { activeStep: activeStep, orientation: "vertical", children: steps.map((step, index) => {
                    var _a, _b, _c;
                    return (_jsxs(Step, { children: [_jsx(StepLabel, { optional: index === steps.length - 1 ? (_jsx(Typography, { variant: "caption", children: t('Laatste stap', 'nav') })) : null, children: t(step.label, 'nav') }), _jsxs(StepContent, { children: [index === activeStep && (_jsx(_Fragment, { children: children })), _jsxs(Box, { sx: { mb: 2 }, children: [((_a = flow.currentRoute) === null || _a === void 0 ? void 0 : _a.actionLabel) && (_jsx(Box, { sx: { mt: 1, mr: 1 }, children: _jsx(Button, { onClick: flow.onNext, sx: { mr: 1 }, variant: "contained", children: (_c = (_b = flow.currentRoute) === null || _b === void 0 ? void 0 : _b.actionLabel) !== null && _c !== void 0 ? _c : t('Volgende', 'nav') }) })), hasBack && activeStep > 0 && (_jsx(Button, { color: "inherit", disabled: activeStep === 0, onClick: flow.onPrevious, sx: { mt: 1, mr: 1 }, children: t('Vorige', 'nav') }))] })] })] }, step.label));
                }) }) }) }));
};
export default VerticalNav;
